/**
 * Autoplay looping words inside <uber> tags in the title, with slide-up animation.
 */
(function($, Drupal, once) {
  Drupal.behaviors.loopingTitle = {
    attach: function(context, settings) {
      function initLoopingTitle() {
        once('looping-title', '.nerivio-powerband-variation__title', context).forEach(function(titleEl) {
          const $title = $(titleEl);

          // Gather words from looping field
          const loopingWords = [];
          $('#looping-words .looping-word', context).each(function() {
            loopingWords.push($(this).html().trim());
          });

          if (!loopingWords.length) return;

          // Replace <uber> with placeholder span
          const html = $title.html();
          const replaced = html.replace(/<uber>(.*?)<\/uber>/gi, '<span class="uber-placeholder"><div class="slide-word">$1</div></span>');
          $title.html(replaced);

          const $placeholder = $title.find('.uber-placeholder');
          if (!$placeholder.length) return;

          let index = 1;

          // Start looping animation
          setInterval(function() {
            const nextWord = loopingWords[index % loopingWords.length];
            $placeholder.html(`<div class="slide-word">${nextWord}</div>`);
            index++;
          }, 2000);
        });
      }

      initLoopingTitle();
    }
  };
})(jQuery, Drupal, once);
